import { createSlice } from "@reduxjs/toolkit";
import { set } from "date-fns";

const welcomePopupSlice = createSlice({
  name: "welcomePopup",
  initialState: {
    isWelcomePopupOpen: false,
  },
  reducers: {
    openWelcomePopup: (state) => {
      state.isWelcomePopupOpen = true;
    },
    closeWelcomePopup: (state) => {
      state.isWelcomePopupOpen = false;
    },
    setWelcomePopup: (state, action) => {
      state.isWelcomePopupOpen = action.payload;
    },
  },
});

export const {
  openWelcomePopup,
  closeWelcomePopup,
  setWelcomePopup,
} = welcomePopupSlice.actions;

export default welcomePopupSlice;
